import React, { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import './index.scss'

interface InputShareEditProps {
    label: string
    shareError: string
    onChange(value: number | null): void
    value?: number | null
}

const InputShareEdit = ({ label, shareError, onChange, value }: InputShareEditProps) => {
    const [share, setShare] = useState<string>(value ? value.toString() : value === 0 ? '0' : '')
    const [widthInput, setWidthInput] = useState<number | null>(null)
    const widthCheckerId = useRef(`${Math.floor(Math.random() * 1000)}_${Math.floor(Math.random() * 1000)}`)
    const id = useRef(`share_${Math.floor(Math.random() * 100000)}`)

    const widthController = () => {
        const widthChecker = document.getElementById(widthCheckerId.current)
        setWidthInput(widthChecker && widthChecker.offsetWidth)
    }

    const getShares = (e: any) => {
        const prevValue = share
        const inputValue = e.target.value
        const stringArray = inputValue.split('.')

        if (stringArray.length > 2) {
            setShare(prevValue)
        } else if (stringArray.length === 2 && !stringArray[0]) {
            setShare(0 + '.' + stringArray[1])
        } else if (isNaN(+stringArray[0]) || (stringArray[1] && isNaN(+stringArray[1]))) {
            setShare(prevValue)
        } else if (stringArray[0].length > 2 || (stringArray[1] && stringArray[1].length > 2)) {
            if (+stringArray[0] === 100) {
                setShare('100')
                onChange(100)
                return
            }
            setShare(prevValue)
        } else {
            setShare(inputValue)
            onChange(!inputValue && inputValue !== '0' ? null : +inputValue)
        }
    }

    useEffect(() => {
        widthController()
    })

    return (
        <div className="share-edit-component">
            <p className="label small">{label}</p>
            <label htmlFor={id.current} className={clsx('percent-area', shareError && 'invalid')}>
                <input
                    type="string"
                    id={id.current}
                    style={{ width: widthInput + 'px' }}
                    value={share}
                    onChange={getShares}
                />
                <span>%</span>
                <p className="widthChecker" id={widthCheckerId.current}>
                    {share}
                </p>
            </label>
            <p className="error small">{shareError}</p>
        </div>
    )
}

export default InputShareEdit
